import { ApiResponses } from 'lib/trpcClient';
import { realisation as rules } from 'further-ui/validations';
import { AllocationRule } from 'further-types/lp/allocations';
import { CurrencyCode } from 'further-types/lp/vehicle';
export type InvestmentHistory = ApiResponses['asset']['getInvestmentHistory'];

export type HoldingClassRealisations =
  rules.CreateRealisationFormValues['holdingClassRealisation'];

export type InvestmentAllocation = {
  holdingClassId: string;
  commitmentId: string;
  withholdingTaxPayable: number;
  investmentId: string;
  investmentCurrency: CurrencyCode;
  allocationPercentage: number;
  allocationType: AllocationRule;
  investorName: string;
  investmentDate: Date;
  holdingClassName: string;
  unitsAllocated: number;
  originalAllocationPercentage: number;
  receivedConsideration: number;
  earnoutConsideration: number;
  escrowConsideration: number;
};

export type Considerations = rules.CreateRealisationFormValues['consideration'];

export type RealisationFormState = {
  consideration: Array<{
    index: number;
    showAllocationsTable: boolean;
    disableAllocationsInputs: boolean;
    holdingClassInvestmentsConsiderationValues: Array<HoldingClassInvestmentsConsiderationValues>;
  }>;
};

export type HoldingClassInvestmentsConsiderationValues = {
  holdingClassId?: string;
  investmentId?: string;
  investmentCurrency: CurrencyCode;
  investmentDate?: Date;
  holdingClassName?: string;
  unitsRealised: number;
  receivedConsiderationPerUnit: number;
  receivedConsiderationTotal: number;
  escrowConsiderationPerUnit: number;
  escrowConsiderationTotal: number;
  earnoutConsiderationPerUnit: number;
  earnoutConsiderationTotal: number;
  withholdingTaxPayable: number;
};

export type InvestorAllocationTotals = {
  investorName: string;
  commitmentId: string;
  averageAllocationPercentage: number;
  receivedConsideration: number;
  escrowConsideration: number;
  earnoutConsideration: number;
  withholdingTaxPayable: number;
  total: number;
};

export type WithholdingTaxAllocation = {
  commitmentId: string;
  totalCommitmentLcy: number;
  withholdingTaxExempt: boolean;
  investorName: string;
};

export enum ConsiderationType {
  UnitsRealised = 'unitsRealised',
  ReceivedConsiderationPerUnit = 'receivedConsiderationPerUnit',
  ReceivedConsiderationTotal = 'receivedConsiderationTotal',
  EscrowConsiderationPerUnit = 'escrowConsiderationPerUnit',
  EscrowConsiderationTotal = 'escrowConsiderationTotal',
  EarnoutConsiderationPerUnit = 'earnoutConsiderationPerUnit',
  EarnoutConsiderationTotal = 'earnoutConsiderationTotal',
  WithholdingTaxPayable = 'withholdingTaxPayable',
}
